import { render } from "./HomePlatformStatistics.vue?vue&type=template&id=41c92170"
import script from "./HomePlatformStatistics.vue?vue&type=script&lang=js"
export * from "./HomePlatformStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__